/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setOrderLiveActivityToken} from '../api'

export const useMutationSetOrderLiveActivityToken = createReactQueryMutationHook('setOrderLiveActivityToken', setOrderLiveActivityToken)
